import { render, staticRenderFns } from "./OsAntesDisc.vue?vue&type=template&id=7162ea38&scoped=true"
import script from "./OsAntesDisc.vue?vue&type=script&lang=ts"
export * from "./OsAntesDisc.vue?vue&type=script&lang=ts"
import style0 from "./OsAntesDisc.vue?vue&type=style&index=0&id=7162ea38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7162ea38",
  null
  
)

export default component.exports